import { Component, Input } from '@angular/core';
import { CommonModule } from "@angular/common";
import { SharedModule } from "../../../@commons/ui-components/shared.module";
import { ArticleListResponse } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/responses/article/article-list.response';
import { Router } from '@angular/router';
import { HexToHsl } from '../../pipes/HexToHsl';

@Component({
    selector: 'vw-article',
    imports: [
        SharedModule,
        CommonModule,
        HexToHsl
    ],
    templateUrl: './article.component.html',
    styleUrl: './article.component.scss'
})
export class ArticleComponent {
  @Input() article: ArticleListResponse;
  /**
   * Format carte, pour une grille de deux par rangée.
   *
   * La bannière pleine largeur est juste pour une liste d'articles ; sur
   * l'accueil, elle prenait la hauteur de trois blocs utiles.
   */
  @Input() compact = false;
  constructor(private router: Router) { }
  onArticleClicked(articleUid: number) {
    this.router.navigate(['/article', articleUid]);
  }
}
